import * as React from "react";
import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Loading from "../components/Loading";
import { getSafeRedirectUrl } from "../utils/redirectValidator";

const SignOut: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const redirectUrl = getSafeRedirectUrl(searchParams);

  useEffect(() => {
    const logoutUser = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/auth/logout`,
          {
            method: "POST",
            credentials: "include",
          }
        );

        if (response.ok) {
          navigate(`/signin${redirectUrl ? `?redirect=${encodeURIComponent(redirectUrl)}` : ""}`, { replace: true });
        } else {
          throw new Error("Logout failed");
        }
      } catch (err) {
        console.error("Logout error:", err);
        navigate("/signin", { replace: true });
      }
    };

    logoutUser();
  }, [navigate, redirectUrl]);

  return <Loading message="Signing you out..." />;
};

export default SignOut;
